export interface PaymentResponse {
  payment_id: string;
  token: string;
  self_url: string;
  third_party_url: string;
  third_party: ThirdPartyEnum;
  status: PaymentStatus;
  amount: number;
}

export function areEqualStatuses(
  status1: PaymentStatus,
  status2: PaymentStatus
) {
  return status1.status === status2.status && status1.type === status2.type;
}

export interface PaymentStatus {
  type: PaymentType;
  status: PaymentState;
}

export interface PaymentStatus {
  type: PaymentType;
  status: PaymentState;
}

export enum PaymentType {
  AUB = "AUB",
  BLO = "BLO",
  CAP = "CAP",
  LIB = "LIB",
  COB = "COB",
  REC = "REC",
}

export enum ThirdPartyEnum {
  MCP = "MCP",
  LIB = "LIB",
  MC2P = "MC2P",
  SPREEDLY = "SPREEDLY",
}

export enum PaymentState {
  OK = "OK",
  KO = "KO",
  PND = "PND",
}

export class Payment {
  constructor(
    public paymentId = "",
    public token = "",
    public selfUrl = "",
    public thirdPartyUrl = "",
    public thirdParty: ThirdPartyEnum = ThirdPartyEnum.MCP,
    public status: PaymentStatus = {
      type: PaymentType.AUB,
      status: PaymentState.PND,
    },
    public amount: number = 0
  ) {}
}

/* NEW WALLET PAYMENT INTERFACES */
export enum PaymentSelectorEnum {
  CREDIT_CARD = "CREDIT_CARD",
  GOOGLE = "GOOGLE",
  APPLE = "APPLE",
  EXPRESS = "EXPRESS",
}

export enum PaymentMethodEnum {
  CREDIT_CARD = "CREDIT_CARD",
  WALLET = "WALLET",
}

export enum PaymentWindow {
  SELECTOR = "SELECTOR",
  TPV = "TPV",
  WALLET = "WALLET",
}

export enum PaymentTypesEnum {
  GOOGLE = "GOOGLE",
  APPLE = "APPLE",
}

export enum TransactionReasonEnum {
  POP = "POP",
  DE1 = "DE1",
  DEC = "DEC",
  DEM = "DEM",
  DET = "DET",
  DEP = "DEP",
  DEU = "DEU",
  PAN = "PAN",
  PPC = "PPC",
  PPO = "PPO",
  RCA = "RCA",
  RCO = "RCO",
  REM = "REM",
  REV = "REV",
  ALT = "ALT",
  RTF = "RTF",
}

export enum FlowEnum {
  PAYMENT = "PAYMENT",
  ECOMMERCE = "ECOMMERCE",
}

export interface WalletDisplayConfig {
  show: boolean;
  payment: PaymentSelectorEnum | null;
}
